import { ReactComponent as ArrowRight } from "../../../../../images/chevron-right.svg";
import { ReactComponent as ArrowLeft } from "../../../../../images/chevron-left.svg";
import LibraryObjectViewType from "../../../LibraryObjectCard/LibraryObjectViewType";
import LibraryObjectCard from "./../../../LibraryObjectCard/LibraryObjectCard";
import { LibraryCommonListTypes } from "../../LibraryCommonListPanel";
import OwlCarousel from "react-owl-carousel3";
import classnames from "classnames";
import "./LibraryCommonList.css";
import { useEffect, useState } from "react";
import { isUserStudent } from "../../../../../services/authUtil";
import { LibraryObjectType } from "../../../../../model/library";
import TalaeraRoutes from "../../../../routes/TalaeraRoutes";
import { useNavigate } from "react-router-dom";
import Paywall from "../../../../Paywall";

import useUser from "../../../../../hooks/useUser";
import { HStack } from "components/Stack";

const MIN_LARGE_SCREEN_WIDTH = 1200;

const LibraryCommonList = props => {
  const [nextEnabled, setNextEnabled] = useState(true);
  const [previousEnabled, setPreviousEnabled] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isOpenPlanUpgradeModal, setIsOpenPlanUpgradeModal] = useState(false);
  const navigate = useNavigate();
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const hasProAccess = useUser()?.student?.has_pro_access;

  const totalCount = props.totalCount || 0;

  const isLargeScreen = windowSize.width > MIN_LARGE_SCREEN_WIDTH;

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);

    // Clean up the event listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isLargeScreen && props.objects.length <= 3) {
      setNextEnabled(false);
      setPreviousEnabled(false);
    }
  }, [props.objects, isLargeScreen]);

  useEffect(() => {
    if (Math.ceil(props.objects.length / 9) < props.page) {
      props.fetchMore && props.fetchMore();
    }
    // eslint-disable-next-line
  }, [props.page]);

  const handleChanged = e => {
    const item = e?.item;

    if (!isLargeScreen && item?.index < objects?.length - 1 && !nextEnabled) {
      setNextEnabled(true);
      setCurrentIndex(item?.index);
    }

    if (isLargeScreen && item?.index + 3 >= objects?.length) {
      setNextEnabled(false);
      setCurrentIndex(objects?.length - 3);
    }

    if (isLargeScreen && item?.index + 3 < objects?.length && !nextEnabled) {
      setNextEnabled(true);
      setCurrentIndex(item?.index);
    }

    if (item?.index === 0) {
      setPreviousEnabled(false);
      setCurrentIndex(item?.index);
    } else {
      setPreviousEnabled(true);
      setCurrentIndex(item?.index);
    }

    if (totalCount <= objects?.length && item?.index === objects?.length - 1) {
      setNextEnabled(false);
      setCurrentIndex(item?.index);
    }

    if (
      (item?.index === objects?.length - 2 || item?.index === objects?.length - 1) &&
      !loading &&
      totalCount > objects.length
    ) {
      setLoading(true);
      setCurrentIndex(item?.index);
    }
  };

  let objects = null;
  let isChapterList = props.objects.some(i => i.type === LibraryObjectType.LESSON);
  if (props.objects && props.objects.length > 0) {
    objects = props.objects.map(object => {
      let actionName = null;

      if (props.actionName) {
        actionName = props.actionName;
      } else if (object.type === LibraryObjectType.COURSE) {
        actionName = "View Course";
      } else if (object.type === LibraryObjectType.FOLDER) {
        actionName = "View Topics";
      }

      return (
        <LibraryObjectCard
          isLocked={isUserStudent() && object.tier === "pro" && !hasProAccess}
          key={object.id}
          object={object}
          actionLabel={actionName}
          isProgress={props.isProgress}
          type={LibraryObjectViewType.LIST}
          listType={props.type}
          hasLesson={isChapterList}
          onOpenPlan={() => setIsOpenPlanUpgradeModal(true)}
        />
      );
    });
  }

  /**
   * Handle previous and next button click event
   * Catch the events of displayed buttons and trigger the click events of navigation buttons of owl carousel
   * @param direction
   */
  const handleClick = direction => {
    if (direction === "next") {
      const nextElement = document.getElementsByClassName(
        `owl-next-${props.sectionIndex}`
      )[0];
      if (nextElement) {
        nextElement.click();
      }
    } else {
      const prevElement = document.getElementsByClassName(
        `owl-prev-${props.sectionIndex}`
      )[0];
      if (prevElement) {
        prevElement.click();
      }
    }
  };

  const handleClosePlan = () => {
    setIsOpenPlanUpgradeModal(false);
  };

  return (
    <div className="library-common-list">
      {isOpenPlanUpgradeModal && (
        <Paywall
          enable
          onUpgrade={() => navigate(TalaeraRoutes.buildPlanDetailsPath())}
          triggerContainerClassName="btn register-workshop"
          defaultOpen={isOpenPlanUpgradeModal}
          onClose={handleClosePlan}
          onSuccess={() => setIsOpenPlanUpgradeModal(false)}
        />
      )}
      {/* eslint-disable-next-line multiline-ternary */}
      {props.isRecommended ? (
        <HStack>
          {!(!nextEnabled && !previousEnabled) && (
            <div className="carousel-button-left">
              <div
                className={`carousel-button-item ${previousEnabled ? "" : "disabled"}`}
                onClick={() => previousEnabled && handleClick("previous")}
              >
                <ArrowLeft />
              </div>
            </div>
          )}
          <div className="slider-recommended">
            <OwlCarousel
              className="owl-carousel owl-theme"
              margin={24}
              items={1}
              dots={false}
              onChanged={handleChanged}
              startPosition={currentIndex}
              smartSpeed={250}
              navClass={[
                `owl-prev-${props.sectionIndex}`,
                `owl-next-${props.sectionIndex}`,
              ]}
            >
              {objects}
            </OwlCarousel>
          </div>
          {!(!nextEnabled && !previousEnabled) && (
            <div className="carousel-button-right">
              <div
                className={`carousel-button-item ${nextEnabled ? "" : "disabled"}`}
                onClick={() => nextEnabled && handleClick("next")}
              >
                <ArrowRight />
              </div>
            </div>
          )}
        </HStack>
      ) : props.type === LibraryCommonListTypes.OBJECT && props.isSlide ? (
        // eslint-disable-next-line multiline-ternary
        <div className="slider">
          {!(!nextEnabled && !previousEnabled) && (
            <div className="carousel-button">
              <div
                className={`carousel-button-item ${previousEnabled ? "" : "disabled"}`}
                onClick={() => previousEnabled && handleClick("previous")}
              >
                <ArrowLeft />
              </div>
              <div
                className={`carousel-button-item ${nextEnabled ? "" : "disabled"}`}
                onClick={() => nextEnabled && handleClick("next")}
              >
                <ArrowRight />
              </div>
            </div>
          )}

          <OwlCarousel
            className="owl-carousel owl-theme"
            margin={24}
            items={1}
            dots={false}
            onChanged={handleChanged}
            startPosition={currentIndex}
            smartSpeed={250}
            navClass={[
              `owl-prev-${props.sectionIndex}`,
              `owl-next-${props.sectionIndex}`,
            ]}
          >
            {objects}
          </OwlCarousel>
        </div>
      ) : (
        <>
          <div
            className={classnames("list-style", {
              "is-topic": props.type === LibraryCommonListTypes.FOLDER,
            })}
          >
            {objects}
          </div>

          {props.type === LibraryCommonListTypes.FOLDER && (
            <div className="slider mobile is-topic">
              <div className="carousel-button">
                <div
                  className={`carousel-button-item ${previousEnabled ? "" : "disabled"}`}
                  onClick={() => handleClick("previous")}
                >
                  <ArrowLeft />
                </div>
                <div
                  className={`carousel-button-item ${nextEnabled ? "" : "disabled"}`}
                  onClick={() => handleClick("next")}
                >
                  <ArrowRight />
                </div>
              </div>

              <OwlCarousel
                className="owl-carousel owl-theme"
                margin={24}
                // stagePadding={ 8 }
                items={1}
                dots={false}
                onChanged={handleChanged}
                startPosition={currentIndex}
                smartSpeed={250}
                navClass={[
                  `owl-prev-${props.sectionIndex}`,
                  `owl-next-${props.sectionIndex}`,
                ]}
              >
                {objects?.reduce((wrappers, object, index) => {
                  return index % 2 && index < objects.length
                    ? [
                        ...wrappers,
                        <div className="object-card-wrapper folder-card-mobile-wrapper">
                          {object}
                          {objects[index + 1]}
                        </div>,
                      ]
                    : wrappers;
                }, [])}
              </OwlCarousel>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default LibraryCommonList;
